import {Alert, Center} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import product from '../../../config/product';

// What a signed-in person who may not manage people sees. It stays put: a
// redirect from here would bounce off "/" and back (FNP-2015).
export const NoAccessPage = () => (
    <Center p='xl'>
        <Alert color='gray' title={I18n.get('You do not have access to this directory')} maw={560}>
            {`${I18n.get('You are signed in, but your account is not allowed to manage people in')} ${product.displayName}. ${I18n.get('Ask a platform administrator if you need access.')}`}
        </Alert>
    </Center>
);
